import { DefaultAttributeValue } from '@source-components-react/types';
import {
  DEFAULT_LIST_ITEMS,
  DEFAULT_LIST_KIND,
  LIST_INLINE_STYLES_ATTRIBUTE,
  LIST_ITEMS_ATTRIBUTE,
  LIST_KIND_ATTRIBUTE,
  LIST_LINKS_ATTRIBUTE,
  LIST_MARKER_ATTRIBUTE,
  LIST_REVERSED_ATTRIBUTE,
  LIST_START_ATTRIBUTE,
} from './list-attributes';

export const defaultAttributeValues: DefaultAttributeValue[] = [
  {
    name: LIST_ITEMS_ATTRIBUTE,
    defaultValues: {
      all: DEFAULT_LIST_ITEMS,
    },
  },
  {
    name: LIST_KIND_ATTRIBUTE,
    defaultValues: {
      all: DEFAULT_LIST_KIND,
    },
  },
  // Marker, start and reversed default to unset on purpose: the browser
  // already renders disc for unordered and 1, 2, 3 for ordered, and an
  // attribute that is not set is one the render path does not emit.
  {
    name: LIST_MARKER_ATTRIBUTE,
    defaultValues: {},
  },
  {
    name: LIST_START_ATTRIBUTE,
    defaultValues: {},
  },
  {
    name: LIST_REVERSED_ATTRIBUTE,
    defaultValues: {},
  },
  {
    name: LIST_LINKS_ATTRIBUTE,
    defaultValues: {},
  },
  {
    name: LIST_INLINE_STYLES_ATTRIBUTE,
    defaultValues: {},
  },
];
